import { createFileRoute } from '@tanstack/react-router'
import { LemlistCompanyLookup } from '@/features/admin/lemlist-company-lookup'

export const Route = createFileRoute(
  '/_authenticated/admin/lemlist-company-lookup'
)({
  component: LemlistCompanyLookup,
})
